module.exports = __webpack_public_path__ + "img/business_license_default.89c31c34.svg";